import { React } from 'react';
import { Shelf } from '../components';

export default function Forest() {
    return (
        <div className="forest">                      
            <Shelf shelfName="Forest" tableItemsPath="recode/forest/paths"/>
        </div>        
    )
};